import { gql } from "@apollo/client";

const UploadsMutation = gql`
  mutation createUpload(
    $userId: UUID!
    $projectName: String
    $zipFileName: String!
    $zipFileSize: BigInt!
    $bulk: Boolean
  ) {
    createUpload(
      input: {
        upload: {
          userId: $userId
          projectName: $projectName
          zipFileName: $zipFileName
          zipFileSize: $zipFileSize
          isBulk: $bulk
        }
      }
    ) {
      upload {
        id
        presignedUrl {
          url
        }
        uploaded
        zipFileName
        zipFileSize
      }
    }
  }
`;

const hash = "223c9138ae4fa19f08d49dd0a5262a2ba3fbdbf01bac69d70e79d41e128462f4";

export { UploadsMutation, hash };
